import React, { Component } from 'react';
import page1 from '../../assets/images/userGuide/page1.jpg';
import page2 from '../../assets/images/userGuide/page2.jpg';
import page3 from '../../assets/images/userGuide/page3.jpg';
import {Helmet} from "react-helmet";
import metatags from '../static/metatags';
class UserGuide extends React.Component {
  componentDidMount = () => {
    window.scrollTo(0, 0);
    this.props.headerHideFun();
    this.props.footerHideFun();
  };

  render() {
    return (
      <>
        <section className="cmx-userguide-page">
          <Helmet>
            <title>{metatags.commonMetatag.title}</title>
            <meta name="description" content={metatags.commonMetatag.description} />
          </Helmet>
          <section className='content'>
            <a onClick={this.props.guideCloseBtn} className='close-icon' href='javascript:;' title=''>&nbsp;</a>
            <figure>
              <img src={page1} alt="User Guide" className="img-fluid" />
            </figure>
            <figure>
              <img src={page2} alt="User Guide" className="img-fluid" />
            </figure>
            <figure>
              <img src={page3} alt="User Guide" className="img-fluid" />
            </figure>
          </section>
        </section>
      </>
    )
  }
}

export default UserGuide;
